import { Route } from '@angular/router';

import { NotAllowedOrganizationComponent } from './not-allowed-organization.component';

export const notAllowedOrganizationRoute: Route = {
    path: 'nonConsentito',
    component: NotAllowedOrganizationComponent,
    data: {
        pageTitle: 'pagetitles.notallowedoperation'
    }
};
